import { ArrowLeft } from "@phosphor-icons/react"
import { Breadcrumbs, SpinnerOverlay } from "@vesatogo/grass-core"
import dayjs from "dayjs"
import { Link, useNavigate, useParams } from "react-router-dom"
import { CountDownTimer } from "~/components/CountDownTimer"
import { AttachmentsCard } from "~/components/DemandDetails/AttachmentsCard"
import { CampaignSummary } from "~/components/DemandDetails/CampaignSummary"
import { EnquiriesTable } from "~/components/DemandDetails/EnquiriesTable"
import { PattiSummary } from "~/components/DemandDetails/PattiSummary"
import { QuickActionsCard } from "~/components/DemandDetails/QuickActionsCard"
import { AppRoutes } from "~/constants/routes"
import {
  useOfferDetailQuery,
  useOfferWhatsAppSummaryQuery,
} from "~/generated/graphql"

export const OfferDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [{ data, fetching }, refetch] = useOfferDetailQuery({
    variables: {
      id: id,
    },
    pause: !id,
  })

  const [{ data: campaignSummary }] = useOfferWhatsAppSummaryQuery({
    variables: {
      id: id,
    },
    pause: !id || !data?.offers_by_pk,
  })

  return (
    <div className={"bg-gray-50 min-h-screen"}>
      <header className="bg-white p-3 border-b border-gray-200 flex items-center gap-4">
        <SpinnerOverlay show={fetching} />
        <button
          onClick={() => navigate(-1)}
          className="p-1 hover:bg-gray-100 rounded-full"
        >
          <ArrowLeft size={20} className="text-gray-600" />
        </button>
        <Breadcrumbs
          items={[
            {
              text: "Offer's Listing",
              link: AppRoutes.offerManagement,
              isActive: false,
            },
            {
              text: "Offer details",
              link: AppRoutes.offerDetail(id?.toString() || "new"),
              isActive: true,
            },
          ]}
          linkRenderer={(link, item) => {
            return <Link to={link as any}>{item}</Link>
          }}
        />
      </header>

      <main className={"p-6"}>
        <div className="flex gap-6 max-w-[1200px] mx-auto bg-white p-4 shadow-sm !rounded-2xl ">
          {/* Left Column */}
          <div className="flex-1 flex flex-col gap-6">
            <PattiSummary data={data?.offers_by_pk} type="offer" />
            <CampaignSummary data={campaignSummary?.offers_by_pk} />
            <EnquiriesTable
              pattiId={id as any}
              type="offer"
              disableOrderCreation={
                data?.offer_order_picked_aggregate?.aggregate?.sum?.quantity >=
                data?.offers_by_pk?.quantity
              }
              status={data?.offers_by_pk?.status}
            />
          </div>

          {/* Right Column (Sidebar) */}
          <div className="relative w-[320px] shrink-0">
            <div className=" border-gray-300 border-1 p-3 rounded-lg fixed">
              <div className=" flex flex-col gap-4 h-full">
                <CountDownTimer
                  startTime={dayjs(data?.offers_by_pk?.start_date_time)}
                  endTime={dayjs(data?.offers_by_pk?.end_date_time)}
                  currentStatus={data?.offers_by_pk?.status as any}
                  refetch={refetch}
                />
                <AttachmentsCard
                  attachments={data?.offers_by_pk?.attachments || []}
                />
                <QuickActionsCard
                  type="offer"
                  id={id as any}
                  status={data?.offers_by_pk?.status}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default OfferDetails
